import { render, staticRenderFns } from "./Trailer.vue?vue&type=template&id=33e6d5ac"
import script from "./Trailer.vue?vue&type=script&lang=ts"
export * from "./Trailer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports